"use strict";

var LoggerInstance = require("js-logger").get("MyRecurringHelper");

var AccountStore = require("./AccountStore");

var Spinner = require("../client/Spinner");

var AccountApi = require("../api/AccountApi");

var ActionsHelper = require("../actions/ActionsHelper");
var MyPledgesHelper = require("./MyPledgesHelper");
var MyRecurringRefresh = require("./MyRecurringRefresh");
var MySponsorshipsHelper = require("./MySponsorshipsHelper");

var PaymentHelper = require("../commonComponents/PaymentHelper");
var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");
var InputHelper = require("../shared/InputHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var myPledgesSelector = "[data-component='myPledges']";

var mySponsorshipsSelector = "[data-component='mySponsorships']";

var myRecurringSelector = "[data-component='myRecurring']";
var myRecurringDonationEditDonationAmountSelector = "[data-component='myRecurringDonations.edit.donationAmount']";
var myRecurringPopulatedSingleRecurringSelector = "[data-component='myRecurring.populated.singleRecurring']";
var myRecurringDonationsSelector = "[data-component='myRecurringDonations']";
var myRecurringDonationsPopulatedViewSelector = "[data-component='myRecurringDonations.populated.view']";
var myRecurringDonationsEditSelector = "[data-component='myRecurringDonations.edit']";
var myRecurringHeaderSelector = "[data-component='myRecurringHeader']";
var myRecurringHeaderViewSelector = "[data-component='myRecurringHeader.view']";
var myRecurringHeaderEditSelector = "[data-component='myRecurringHeader.edit']";
var myRecurringPaymentSelector = "[data-component='myRecurringPayment']";
var myRecurringPaymentEditSelector = "[data-component='myRecurringPayment.editPayment']";
var myRecurringPaymentViewSelector = "[data-component='myRecurringPayment.viewCreditCard'],[data-component='myRecurringPayment.viewEft']";

var MyRecurringHelper = {
	cancelRecurringDonationEdit: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelRecurringDonationEdit"));
		if (!event) {
			return false;
		}

		var $donationEdit = $(event.target).closest(myRecurringDonationsEditSelector);
		var donationId = $donationEdit.attr("data-donation-id");

		Spinner.showSpinner($donationEdit);
		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ false, {
			donationId,
			usingDonations: true
		}).always(() => Spinner.removeSpinner($donationEdit));

		return false;
	},

	cancelRecurringHeaderEdit: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelRecurringHeaderEdit"));
		if (!event) {
			return false;
		}

		var $headerEdit = $(event.target).closest(myRecurringHeaderEditSelector);
		Spinner.showSpinner($headerEdit);

		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ false, {
			usingHeader: true
		}).always(() => Spinner.removeSpinner($headerEdit));

		return false;
	},

	cancelRecurringPaymentEdit: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelRecurringPaymentEdit"));
		if (!event) {
			return false;
		}

		var $paymentEdit = $(event.target).closest(myRecurringPaymentEditSelector);
		Spinner.showSpinner($paymentEdit);

		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ false, {
			usingPayment: true
		}).always(() => Spinner.removeSpinner($paymentEdit));

		return false;
	},

	cancelWholeRecurring: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("cancelRecurring"));
		if (!event) {
			return false;
		}

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: AccountStore.get("wizardMyRecurringDisplayMessages").cancelRecurring,
			title: ""
		}, (result) => {
			if (result) {
				Spinner.showSpinner();

				var $currentRecurring = $(event.target).closest(myRecurringPopulatedSingleRecurringSelector);
				var recurringId = $currentRecurring.attr("data-recurring-id");

				//Call API to delete
				AccountApi.myRecurringCancel(recurringId).done(() => {
					HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($currentRecurring);
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus);
				}).always(() => Spinner.removeSpinner());
			}
		});

		return false;
	},

	deleteRecurringDonation: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("deleteRecurringDonation"));
		if (!event) {
			return false;
		}

		var $target = $(event.target);
		var $currentRecurring = $target.closest(myRecurringPopulatedSingleRecurringSelector);
		var recurringId = $currentRecurring.attr("data-recurring-id");

		var $donationPopulatedView = $target.closest(myRecurringDonationsPopulatedViewSelector);
		var donationId = $donationPopulatedView.attr("data-donation-id");
		var pledgeId = $donationPopulatedView.attr("data-pledge-id");

		var message;

		if (pledgeId > 0) {
			message = AccountStore.get("wizardMyRecurringDisplayMessages").deleteRecurringDonationWithPledge;
		} else {
			message = AccountStore.get("wizardMyRecurringDisplayMessages").deleteRecurringDonation;
		}

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: message
		}, (result) => {
			if (result) {
				Spinner.showSpinner();

				//Call API to delete
				AccountApi.myRecurringDeleteDonation(recurringId, donationId).done((data) => {
					data = data || {};
					data.response = data.response || {};
					if (data.response.deleteType === "recurringHeader") {
						//There was only 1 donation distribution, we are canceling the recurring
						HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($currentRecurring);
						Spinner.removeSpinner();
					} else {
						//Since we only deleted a single donation, we need to refresh the header as the amounts have changed.
						MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ false, {
							usingHeader: true
						}).always(() => {
							//There was more than 1 donation distribution, so we went ahead and deleted it
							HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($donationPopulatedView);

							Spinner.removeSpinner();
						});
					}
				}).fail((jqXHR, textStatus) => {
					this._resolveError(jqXHR, textStatus);
					Spinner.removeSpinner();
				});
			}
		});

		return false;
	},

	editRecurringDonation: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("editRecurringDonation"));
		if (!event) {
			return false;
		}

		//Getting myRecurring.donations.populated.view
		var $donationView = $(event.target).closest(myRecurringDonationsPopulatedViewSelector);
		Spinner.showSpinner($donationView);

		var donationId = $donationView.attr("data-donation-id");
		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ true, {
			donationId,
			usingDonations: true
		}).always(() => Spinner.removeSpinner($donationView));

		return false;
	},

	editRecurringHeader: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("editRecurringHeader"));
		if (!event) {
			return false;
		}

		//Getting myRecurringHeader.view
		var $headerView = $(event.target).closest(myRecurringHeaderViewSelector);
		Spinner.showSpinner($headerView);

		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ true, {
			usingHeader: true
		}).always(() => Spinner.removeSpinner($headerView));

		return false;
	},

	editRecurringPayment: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("editRecurringPayment"));
		if (!event) {
			return false;
		}

		//Getting myRecurringPayment.view
		var $paymentView = $(event.target).closest(myRecurringPaymentViewSelector);
		Spinner.showSpinner($paymentView);

		MyRecurringRefresh.getMyRecurringHtml(event, /*isEditing*/ true, {
			usingPayment: true
		}).always(() => Spinner.removeSpinner($paymentView));

		return false;
	},

	initializeMyRecurring: function($component) {
		MyRecurringRefresh.initializeMyRecurring($component);
	},

	saveRecurringDonation: function(event) {
		event = this._getEventOrReturn(event, "Save Recurring Donation called successfully.");
		if (!event) {
			return false;
		}

		Spinner.showSpinner();

		var $target = $(event.target);
		var $currentRecurring = $target.closest(myRecurringPopulatedSingleRecurringSelector);
		var recurringId = $currentRecurring.attr("data-recurring-id");
		var myRecurringComponentId = $currentRecurring.closest(myRecurringSelector).attr("id");

		var donationId = $target.closest(myRecurringDonationsEditSelector).attr("data-donation-id");
		var oldPledgeId = $target.closest(myRecurringDonationsEditSelector).attr("data-pledge-id");

		var $editDonationComponent = $target.closest(myRecurringDonationsEditSelector);
		var $editDonationForm = $editDonationComponent.find(`form#editRecurringDonation-${donationId}`);
		var editDonationData = ActionsHelper.serializeForm($editDonationForm);

		//Check if the donation amount is greater than zero
		editDonationData.donationAmount = ActionsHelper.convertFormattedAmountToNumber(editDonationData.donationAmount);
		if (!(Number(editDonationData.donationAmount) > 0)) {
			BootstrapPrompt.alert(AccountStore.get("wizardMyRecurringDisplayMessages").donationAmountGreaterThanZero);
			Spinner.removeSpinner();
			return false;
		}

		//Call API to save
		AccountApi.myRecurringEditDonation(recurringId, donationId, editDonationData, myRecurringComponentId).done((data) => {
			var $data = $(data);
			var postSubmitActionData = SubmitButtonHelper.getPostSubmitActionData("[data-component='myRecurringDonations.edit']");

			var $newHeader = $data.find(myRecurringHeaderSelector);
			var $newDonation = $data.find(`${myRecurringDonationsSelector} [data-donation-id]`);
			var newPledgeId = $newDonation.attr("data-pledge-id");

			MyRecurringRefresh.replaceMyRecurringSubComponent($data, $newHeader, $currentRecurring, myRecurringHeaderSelector);
			MyRecurringRefresh.replaceMyRecurringSubComponent($data, $newDonation, $currentRecurring, `${myRecurringDonationsSelector} [data-donation-id]`);

			this._refreshAssociatedPledgeHtml(oldPledgeId, newPledgeId).done(() => Spinner.removeSpinner());

			SubmitButtonHelper.performPostSubmitAction("[data-component='myRecurringDonations.edit']", {
				actionData: postSubmitActionData
			});
		}).fail((jqXHR, textStatus) => {
			this._resolveError(jqXHR, textStatus);
			Spinner.removeSpinner();
		});

		return false;
	},

	saveRecurringHeader: function(event) {
		event = this._getEventOrReturn(event, "Save Recurring Header called successfully.");
		if (!event) {
			return false;
		}

		Spinner.showSpinner();

		var $target = $(event.target);
		var $currentRecurring = $target.closest(myRecurringPopulatedSingleRecurringSelector);
		var recurringId = $currentRecurring.attr("data-recurring-id");
		var myRecurringComponentId = $currentRecurring.closest(myRecurringSelector).attr("id");
		var $donations = $currentRecurring.find(`${myRecurringDonationsPopulatedViewSelector}, ${myRecurringDonationsEditSelector}`);

		var $editHeaderForm = $target.closest(myRecurringHeaderEditSelector).find("form");
		var editHeaderData = ActionsHelper.serializeForm($editHeaderForm);

		//Call API to save
		AccountApi.myRecurringEditHeader(recurringId, editHeaderData, myRecurringComponentId).done((data) => {
			var $data = $(data);
			var postSubmitActionData = SubmitButtonHelper.getPostSubmitActionData("[data-component='myRecurringHeader.edit']");

			var $newHeader = $data.find(myRecurringHeaderSelector);
			MyRecurringRefresh.replaceMyRecurringSubComponent($data, $newHeader, $currentRecurring, myRecurringHeaderSelector);

			var promises = [];

			$donations.each((index, element) => {
				var deferred = new $.Deferred();

				var recurringDonationId = $(element).attr("data-donation-id");

				MyRecurringRefresh.getMyRecurringHtml(
					{
						target: $(element).closest(myRecurringPopulatedSingleRecurringSelector)
					},
					/*isEditing*/ false,
					{
						donationId: recurringDonationId,
						usingDonations: true
					}
				).done(() => {
					deferred.resolve();
				});

				var pledgeId = $(element).closest(`${myRecurringDonationsPopulatedViewSelector}, ${myRecurringDonationsEditSelector}`).attr("data-pledge-id");

				this._refreshAssociatedPledgeHtml(pledgeId).done(() => {
					deferred.resolve();
				});

				promises.push(deferred);
			});

			$.when.apply(undefined, promises).then(() => Spinner.removeSpinner());

			SubmitButtonHelper.performPostSubmitAction("[data-component='myRecurringHeader.edit']", {
				actionData: postSubmitActionData
			});
		}).fail((jqXHR, textStatus) => {
			this._resolveError(jqXHR, textStatus);
			Spinner.removeSpinner();
		});

		return false;
	},

	saveRecurringPayment: function(event) {
		event = this._getEventOrReturn(event, "Save Recurring Payment called successfully.");
		if (!event) {
			return false;
		}

		var $currentRecurring = $(event.target).closest(myRecurringPopulatedSingleRecurringSelector);

		var components = [
			$currentRecurring.find(myRecurringPaymentEditSelector)
		];

		Spinner.showSpinner();
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner();
				return;
			}

			PaymentHelper.getPaymentData(AccountStore.get("wizardCompanyErrorMessages"), AccountStore.get("wizardCompanyEftErrorMessages"), paymentInformation => {
				if (!paymentInformation) {
					BootstrapPrompt.alert("An error occurred in saving payment.");
					Spinner.removeSpinner();
					return;
				}

				var recurringId = $currentRecurring.attr("data-recurring-id");
				var myRecurringComponentId = $currentRecurring.closest(myRecurringSelector).attr("id");

				AccountApi.myRecurringEditPayment(recurringId, paymentInformation, myRecurringComponentId).done((data) => {
					var $data = $(data);
					var postSubmitActionData = SubmitButtonHelper.getPostSubmitActionData("[data-component='myRecurringPayment.edit']");

					var $newPayment = $data.find(myRecurringPaymentSelector);

					MyRecurringRefresh.replaceMyRecurringSubComponent($data, $newPayment, $currentRecurring, myRecurringPaymentSelector);

					SubmitButtonHelper.performPostSubmitAction("[data-component='myRecurringPayment.edit']", {
						actionData: postSubmitActionData
					});
				}).fail((jqXHR, textStatus) => {
					PaymentHelper.clearPaymentData($currentRecurring);
					this._resolveError(jqXHR, textStatus);
				}).always(() => Spinner.removeSpinner());
			}, () => Spinner.removeSpinner(), $currentRecurring);
		});
		return false;
	},

	_refreshAssociatedPledgeHtml: function(oldRecurringPledgeId, newRecurringPledgeId) {
		var promises = [];

		var $pledgeContainer = $(myPledgesSelector);
		var $pledgeDonations = $pledgeContainer.find(`[data-pledge-id="${oldRecurringPledgeId}"]`);

		$pledgeDonations.each((index, element) => {
			var deferred = new $.Deferred();

			MyPledgesHelper.getMyPledgeHtml(
					{
						target: $(element)
					},
					/*isEditing*/ false,
					newRecurringPledgeId
			).done(() => {
				deferred.resolve();
			});

			promises.push(deferred);
		});

		var $sponsorshipContainer = $(mySponsorshipsSelector);
		var $sponsorshipDonations = $sponsorshipContainer.find(`[data-pledge-id="${oldRecurringPledgeId}"]`);

		$sponsorshipDonations.each((index, element) => {
			var deferred = new $.Deferred();

			MySponsorshipsHelper._getMySponsorshipHtml(
					{
						target: $(element)
					},
					/*isEditing*/ false,
					newRecurringPledgeId
			).done(() => {
				deferred.resolve();
			});

			promises.push(deferred);
		});

		return $.when.apply(undefined, promises).promise();
	},

	_resolveError(jqXHR, textStatus, deferred) {
		if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
			//There was not a partial error, so do what we normally would do.
			ApiHelper.displayErrorMessage(jqXHR);
		}

		if (deferred) {
			deferred.reject(jqXHR, textStatus);
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	}
};

module.exports = MyRecurringHelper;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/MyRecurringHelper.jsx